<h1 class="step-heading">
  <%= I18n.patient.headings.guest %>
</h1>

<div class="step-form">
  <div class="fieldset">
    <div class="section-heading"><%= I18n.patient.headings.patient %></div>

    <div class="field">
      <label class="field-label"><%= I18n.patient.labels.first_name %><span class="field-required">*</span></label>
      <input type="text" name="sparklehp" tabindex="-1" autocomplete="sparklehp" data-appointment-booking-wizard-behaviour="field-input"/>
      <input class="field-input" data-appointment-booking-wizard-behaviour="field-input" type="text" name="first_name" data-testid="<%= testIds.registration.firstName %>" required pattern="<%= I18n.patient.validations.first_name %>" value="<%- first_name %>">
      <span class="validation-error"><%= I18n.errors.required_field %></span>
    </div>

    <div class="field">
      <label class="field-label"><%= I18n.patient.labels.last_name %><span class="field-required">*</span></label>
      <input class="field-input" data-appointment-booking-wizard-behaviour="field-input" type="text" name="last_name" data-testid="<%= testIds.registration.lastName %>" required pattern="<%= I18n.patient.validations.last_name %>" value="<%- last_name %>">
      <span class="validation-error"><%= I18n.errors.required_field %></span>
    </div>

    <div class="field-group">
      <div class="date-of-birth-field"></div>
      <div class="field">
        <label class="field-label"><%= I18n.patient.labels.gender %><span class="field-required">*</span></label>
        <div class="field-input select">
          <select data-appointment-booking-wizard-behaviour="field-input" name="gender" data-testid="<%= testIds.registration.gender %>" required>
            <option value=""><%= I18n.prompts.gender %></option>
            <% AppointmentBooking.config.genders.forEach(function(g) { %>
              <option value="<%= g %>" <% if (gender == g) { %>selected<% } %>><%= g %></option>
            <% }) %>
          </select>
        </div>
        <span class="validation-error"><%= I18n.errors.required_field %></span>
      </div>

      <% if (AppointmentBooking.config.show_ssn_field) { %>
        <div class="field field--ssn">
          <label class="field-label"><%= I18n.patient.labels.last_4_ssn %><span class="field-required">*</span></label>
          <input class="field-input" data-appointment-booking-wizard-behaviour="field-input" type="text" name="last_4_ssn" data-testid="<%= testIds.registration.ssn %>" required placeholder="<%= I18n.placeholders.last_4_ssn %>" minlength="4" maxlength="4" value="<%- last_4_ssn %>">
        </div>
      <% } %>
    </div>

    <div class="age-range-callout-container"></div>

  </div>

  <div class="fieldset">
    <div class="section-heading"><%= I18n.patient.headings.contact %></div>

    <div class="field">
      <label class="field-label"><%= I18n.patient.labels.email %><span class="field-required">*</span></label>
      <input class="field-input" data-appointment-booking-wizard-behaviour="field-input" type="email" name="email" data-testid="<%= testIds.registration.email %>" required value="<%- email %>" placeholder="<%= I18n.patient.placeholders.email %>">
      <span class="validation-error"><%= I18n.errors.incorrect_format.email %></span>
    </div>

    <div class="field">
      <label class="field-label"><%= I18n.patient.labels.primary_phone %><span class="field-required">*</span></label>
      <div class="field-tel">
        <input class="field-input field-tel__input" data-appointment-booking-wizard-behaviour="field-input" type="tel" name="primary_phone" data-testid="<%= testIds.registration.phone %>" pattern="<%= I18n.patient.validations.primary_phone %>" required placeholder="<%= I18n.patient.placeholders.primary_phone %>" value="<%- primary_phone %>">
        <label>
          <select name="primary_phone_type" class="field-tel__select" data-appointment-booking-wizard-behaviour="field-input">
            <% _.forEach(available_phone_types, function(type) { %>
              <option value="<%= type %>" <% if (primary_phone_type == type) { %>selected<% } %>>
                <%= I18n.patient.values.phone_type[type] %>
              </option>
            <% }) %>
          </select>
          <span class="field-tel__caret"></span>
        </label>
      </div>
      <span class="validation-error"><%= I18n.errors.incorrect_format.phone %></span>
    </div>

    <div class="field">
      <label class="field-label"><%= I18n.patient.labels.secondary_phone %></label>
      <div class="field-tel">
        <input class="field-input field-tel__input" data-appointment-booking-wizard-behaviour="field-input" type="tel" name="secondary_phone" pattern="<%= I18n.patient.validations.secondary_phone %>" placeholder="<%= I18n.patient.placeholders.secondary_phone %>" value="<%- secondary_phone %>">
        <label>
          <select name="secondary_phone_type" class="field-tel__select" data-appointment-booking-wizard-behaviour="field-input">
            <% _.forEach(available_phone_types, function(type) { %>
              <option value="<%= type %>" <% if (secondary_phone_type == type) { %>selected<% } %>>
                <%= I18n.patient.values.phone_type[type] %>
              </option>
            <% }) %>
          </select>
          <span class="field-tel__caret"></span>
        </label>
      </div>
      <span class="validation-error"><%= I18n.errors.incorrect_format.phone %></span>
    </div>

    <div class="field">
      <label class="field-label"><%= I18n.patient.labels.address %><span class="field-required">*</span></label>
      <input class="field-input" data-appointment-booking-wizard-behaviour="field-input" type="text" name="street" data-testid="<%= testIds.registration.street %>" required  value="<%- street %>">
      <span class="validation-error"><%= I18n.errors.required_field %></span>
    </div>

    <div class="field">
      <label class="field-label"><%= I18n.patient.labels.address_extra_details %></label>
      <input class="field-input" data-appointment-booking-wizard-behaviour="field-input" type="text" name="street_line2" data-testid="<%= testIds.registration.streetLine2 %>" value="<%- street_line2 %>">
      <span class="validation-error"><%= I18n.errors.required_field %></span>
    </div>

    <div class="field">
      <label class="field-label"><%= I18n.patient.labels.city %><span class="field-required">*</span></label>
      <input class="field-input" data-appointment-booking-wizard-behaviour="field-input" type="text" name="city" data-testid="<%= testIds.registration.city %>" required value="<%- city %>">
      <span class="validation-error"><%= I18n.errors.required_field %></span>
    </div>

    <div class="field-group">
      <div class="field one-third">
        <label class="field-label"><%= I18n.patient.labels.zip_code %><span class="field-required">*</span></label>
        <input class="field-input" data-appointment-booking-wizard-behaviour="field-input" type="text" name="zip_code" data-testid="<%= testIds.registration.zip %>" required pattern="<%= I18n.patient.validations.zip_code %>" value="<%- zip_code %>">
        <span class="validation-error"><%= I18n.errors.incorrect_format.zip_code %></span>
      </div>

      <div class="field">
        <label class="field-label"><%= I18n.patient.labels.state %><span class="field-required">*</span></label>
        <div class="field-input select">
          <select data-appointment-booking-wizard-behaviour="field-input" name="state" data-testid="<%= testIds.registration.state %>" required>
            <option value=""><%= I18n.prompts.state %></option>
            <% AppointmentBooking.config.states.forEach(function(stateOption) { %>
              <option value="<%= stateOption[1] %>" <% if (state == stateOption[1]) { %>selected<% } %>><%= stateOption[0] %></option>
            <% }) %>
          </select>
        </div>
        <span class="validation-error"><%= I18n.errors.required_field %></span>
      </div>
    </div>
  </div>
</div>
